import React, { Component, Fragment } from "react";
import { withRouter } from 'react-router-dom';

import Grid from "@material-ui/core/Grid";
import classes from "./GSTReconciliation.module.css";
import { ValidatorForm } from "react-material-ui-form-validator";
import Button from "@material-ui/core/Button";
import VisibilityIcon from "@material-ui/icons/Visibility";

import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";

import CircularProgress from "@material-ui/core/CircularProgress";
import axios from "../../../../axios-order";
import "../../../../asserts/css/Onboarding.css";
import InputField from "../../../../components/ui/inputField";
import BasicInputField from "../../../../components/ui/basicInput";

import Modal from "react-bootstrap/Modal";
import SelectField from "../../../../components/ui/basicSelectInput";
import RefreshIcon from "@mui/icons-material/Refresh";
import CryptoJS from "crypto-js";
import BoxWrapper from "../../../../components/ui/boxWrapper";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import { IconButton, Tooltip } from "@mui/material";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
 
// ─── SSE utilities ────────────────────────────────────────────────────────────
import { generateUUID } from '../../../../utils/sseUtils';
import { SSE_BASE_URL } from '../../../../axios-order';
// ─────────────────────────────────────────────────────────────────────────────

class GSTReconciliation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sellerName: "Botmantra",
      file_name: "",
      historyTableOriginalData: null,
      historyTable: null,
      loading: false,
      modalShow: false,
      customRoundOff: null,
      threshold_value: 0,
      yearArr: [],
      errorMessage: false,
      fromMonthArr: [
        { id: 4, value: "APR" },
        { id: 5, value: "MAY" },
        { id: 6, value: "JUN" },
        { id: 7, value: "JUL" },
        { id: 8, value: "AUG" },
        { id: 9, value: "SEPT" },
        { id: 10, value: "OCT" },
        { id: 11, value: "NOV" },
        { id: 12, value: "DEC" },
        { id: 1, value: "JAN" },
        { id: 2, value: "FEB" },
        { id: 3, value: "MAR" },
      ],
      toMonthArr: [
        { id: 4, value: "APR" },
        { id: 5, value: "MAY" },
        { id: 6, value: "JUN" },
        { id: 7, value: "JUL" },
        { id: 8, value: "AUG" },
        { id: 9, value: "SEPT" },
        { id: 10, value: "OCT" },
        { id: 11, value: "NOV" },
        { id: 12, value: "DEC" },
        { id: 1, value: "JAN" },
        { id: 2, value: "FEB" },
        { id: 3, value: "MAR" },
      ],
      year: null,
      from_month: null,
      to_month: null,
      roundOff: 0,
      
      // SSE states (replaces polling states)
      isProcessing: false,
      processingMessage: "",

      snackbarOpen: false,
      snackbarMessage: "",
      snackbarSeverity: "success",
    };
    
    // SSE ref — persists across renders without causing re-renders
    this.eventSourceRef = null;
    this.sseOpenedRef = false;
  }
 
  handleBack = () => {
    this.props.history.push('/reconCards');
  };

  componentDidMount = () => {
    this.setFromYearValues();
    this.getReconDetailsAndRedirect();
  };

  componentWillUnmount = () => {
    // ─── Cleanup SSE on unmount ───────────────────────────────────────────────
    if (this.eventSourceRef) {
      this.eventSourceRef.close();
      this.eventSourceRef = null;
    }
  };
 
  handleSnackbarOpen = (message, severity) => {
    this.setState({
      snackbarOpen: true,
      snackbarMessage: message,
      snackbarSeverity: severity,
    });
  };

  handleSnackbarClose = () => {
    this.setState({
      snackbarOpen: false,
      snackbarMessage: "",
      snackbarSeverity: "success",
    });
  };

  // ─── SSE helper ──────────────────────────────────────────────────────────
  initiateReconSSE = (sseToken) => {
    return new Promise((resolve, reject) => {
      if (this.eventSourceRef) {
        this.eventSourceRef.close();
        this.eventSourceRef = null;
      }

      console.log("SSE Starting point");
      this.sseOpenedRef = false;

      const sseUrl = `${SSE_BASE_URL}/api/sse/${sseToken}`;
      const es = new EventSource(sseUrl);
      this.eventSourceRef = es;

      console.log("SSE object created:", sseUrl, "readyState:", es.readyState);

      es.onopen = () => {
        this.sseOpenedRef = true;
        console.log('SSE onopen fired, readyState:', es.readyState);
        resolve();
      };

      es.onmessage = (event) => {
        console.log("RAW SSE:", event.data);
        try {
          const data = JSON.parse(event.data);
          console.log("REAL SSE DATA:", data);
          if (data.status === "done" || data.status === "Pass") {
            console.log("Recon completed via SSE, recon_id:", data.recon_id);
            if (this.eventSourceRef) {
              this.eventSourceRef.close();
              this.eventSourceRef = null;
            }
            // ── VERIFY: check backend log for exact field name ──
            const reconId = data.recon_id || data.gstr1_recon_id;
            this.fetchAndRedirect(reconId);
          }
        } catch (err) {
          console.log("Ignoring non-json SSE message:", event.data);
        }
      };

      es.onerror = (e) => {
        const rs = this.eventSourceRef?.readyState;
        console.log("SSE onerror fired, readyState:", rs, "timestamp:", new Date().toISOString());
        if (rs === 2) {
          console.log("SSE permanently closed (readyState 2)");
          if (this.eventSourceRef) {
            this.eventSourceRef.close();
            this.eventSourceRef = null;
          }
          if (!this.sseOpenedRef) {
            reject(new Error("SSE connection failed permanently"));
          }
        }
      };
    });
      };

  // ─── Fetch report and redirect ────────────────────────────────────────────
  fetchAndRedirect = (reconId) => {
    console.log("fetchAndRedirect called with:", reconId);
    if (!reconId) {
      this.setState({ isProcessing: false, processingMessage: '', loading: false });
      this.handleSnackbarOpen('No recon ID received from SSE.', 'error');
      return;
    }

    axios
      .get(`/arc/get_gst_json/${reconId}`)
      .then((res) => {
        if (res.data.status && res.data.record) {
          this.setState({ isProcessing: false, processingMessage: '', loading: false });
          this.handleSnackbarOpen("GSTR-1 Reconciliation completed! Redirecting...", "success");
          setTimeout(() => {
            this.redirectToReport(reconId);
          }, 1000);
        } else {
          this.setState({ isProcessing: false, processingMessage: '', loading: false });
          this.handleSnackbarOpen('Failed to fetch report. Please refresh.', 'error');
        }
      })
      .catch(() => {
        this.setState({ isProcessing: false, processingMessage: '', loading: false });
        this.handleSnackbarOpen('Error loading report data.', 'error');
      });
  };

 getReconDetailsAndRedirect = () => {
  this.setState({ loading: true });

  axios
    .post(`/get_latest_recon_records`, {
      report_type: "gstr1",
        org_gstin: localStorage.getItem("gst"),
      business_entity_id: localStorage.getItem("business_entity_id")
    })
    .then((res) => {
      if (!res.data) {
        this.handleSnackbarOpen("No reconciliation data available, initiating new reconciliation...", "info");
        this.callUnifiedAutoReconciliation();
        return;
      }

      let reconId = null;
      let foundLocation = "not found";
      
      if (res.data.recon_id) {
        reconId = res.data.recon_id;
        foundLocation = "res.data.recon_id";
      } else if (res.data.gstr1_recon_id) {
        reconId = res.data.gstr1_recon_id;
        foundLocation = "res.data.gstr1_recon_id";
      } else if (res.data.record?.recon_id) {
        reconId = res.data.record.recon_id;
        foundLocation = "res.data.record.recon_id";
      } else if (res.data.record?.gstr1_recon_id) {
        reconId = res.data.record.gstr1_recon_id;
        foundLocation = "res.data.record.gstr1_recon_id";
      } else if (res.data.data?.recon_id) {
        reconId = res.data.data.recon_id;
        foundLocation = "res.data.data.recon_id";
      } else if (res.data.data?.gstr1_recon_id) {
        reconId = res.data.data.gstr1_recon_id;
        foundLocation = "res.data.data.gstr1_recon_id";
      }

      const isValidReconId = (
        reconId !== null && 
        reconId !== undefined && 
        reconId !== "" && 
        reconId !== 0 &&
        reconId !== "null" &&
        reconId !== "undefined" &&
        String(reconId).trim() !== ""
      );
      
      if (isValidReconId) {
        this.handleSnackbarOpen("Loading existing reconciliation...", "info");
        this.checkReconciliationAndRedirect(reconId);
        } else {
        this.handleSnackbarOpen("No existing reconciliation found. Initiating new reconciliation...", "info");
        this.callUnifiedAutoReconciliation();
      }
    })
    .catch((error) => {
      this.handleSnackbarOpen("Initiating new reconciliation...");
      this.callUnifiedAutoReconciliation();
    });
};

  // ─── callUnifiedAutoReconciliation with SSE ───────────────────────────────
  callUnifiedAutoReconciliation = async () => {
    try {
      this.setState({ loading: true, isProcessing: true, processingMessage: 'Opening SSE connection...' });
      this.handleSnackbarOpen("Initiating reconciliation...", "info");

      const sseToken = generateUUID();

      // STEP 1 — Wait until SSE actually opens
      await this.initiateReconSSE(sseToken);
      console.log('SSE confirmed open. Starting recon POST.');
      this.setState({ processingMessage: 'Reconciliation started. Waiting for result...' });

    const requestPayload = {
      report_type: "gstr1",
      org_gstin: localStorage.getItem("gst"),
        business_entity_id: localStorage.getItem("business_entity_id"),
      period_type: "previous_month",
        threshold_value: 5,
        sse_token: sseToken,
        functionality: 'GSTR1 RECON', 
      };

      // STEP 2 — Start recon only AFTER SSE is open
      const res = await axios.post(`/unified_auto_reconciliation`, requestPayload);
      console.log('Recon API response:', res.data);

      if (!res.data || res.data.status === false) {
        if (this.eventSourceRef) { this.eventSourceRef.close(); this.eventSourceRef = null; }
        this.setState({ isProcessing: false, processingMessage: '', loading: false });
        this.handleSnackbarOpen(res.data?.message || "Failed to initiate reconciliation", "error");
          return;
        }

      this.handleSnackbarOpen("Reconciliation initiated. Waiting for result...", "info");
      // Result arrives via SSE → fetchAndRedirect → redirectToReport

    } catch (error) {
      console.error('Error in callUnifiedAutoReconciliation:', error);
      if (this.eventSourceRef) { this.eventSourceRef.close(); this.eventSourceRef = null; }
      this.setState({ isProcessing: false, processingMessage: '', loading: false });
      this.handleSnackbarOpen(
        error?.response?.data?.message || error.message || "Failed to initiate reconciliation",
        "error"
      );
    }
  };

  checkReconciliationAndRedirect = (reconId) => {    
    axios
      .get(`/arc/get_gst_json/${reconId}`)
      .then((res) => {
        if (res.data.status && res.data.record) {
          const record = res.data.record;
          
          if (record.status === "Pass") {
            if (record.json_data && Object.keys(record.json_data).length > 0) {
              this.handleSnackbarOpen("Loading report...", "success");
              this.setState({ loading: false });
              setTimeout(() => {
                this.redirectToReport(reconId);
              }, 500);
            } else {
              this.handleSnackbarOpen("Finalizing report...", "info");
              this.setState({ loading: false });
              this.redirectToReport(reconId);
            }
          } else if (record.status === "Processing" || record.status === "Initiated") {
            this.handleSnackbarOpen("Processing reconciliation... Please wait.", "info");
            this.setState({ loading: false });
            this.redirectToReport(reconId);
          } else if (record.status === "Fail") {
            this.setState({ loading: false });
            const errorMsg = record.json_data?.exception || "Processing failed";
            this.handleSnackbarOpen(`Reconciliation Failed: ${errorMsg}`, "error");
          } else {
            this.setState({ loading: false });
            this.handleSnackbarOpen("Reconciliation data not ready yet", "warning");
          }
        } else {
          this.setState({ loading: false });
          this.handleSnackbarOpen("Unable to fetch reconciliation data", "warning");
        }
      })
      .catch((error) => {
        this.setState({ loading: false });
        this.handleSnackbarOpen(
          `Error: ${error?.response?.data || error.message}`,
          "error"
        );
      });
  };

  redirectToReport = (id) => {
    const encrypt = (text) => {
      return CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(text));
    };
    
    this.props.history.push({
      pathname: `/gstReconUpdatedTabDetails/${encrypt(id)}`,
      data: id,
    });
  };

  setFromYearValues = () => {
    let current_year = new Date().getFullYear();
    let yearArr = [];
    for (let i = current_year - 7; i <= current_year + 5; i++) {
      let startYear = i;
      let endYear = i + 1;
      let endYearShort = endYear.toString().slice(-2);
      yearArr.push({ id: `${startYear}-${endYearShort}`, value: `${startYear}-${endYearShort}` });
    }
    this.setState({
      yearArr: yearArr,
    });
  };

  render() {
    return (
      <React.Fragment>
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '60vh',
          padding: '20px'
        }}>
          <Tooltip title="Back" arrow>
            <IconButton
              onClick={this.handleBack}
              sx={{
                position: 'absolute',
                top: '20px',
                left: '20px',
                borderRadius: '50%',
                padding: '6px',
                color: '#263238',
                fontSize: '20px',
                backgroundColor: '#ffffff',
                height: '36px',
                width: '36px',
                '&:hover': {
                  backgroundColor: '#455a64',
                  color: '#ffffff',
                },
                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)',
                transition: 'background-color 0.3s ease',
              }}
            >
              <ArrowBackIcon sx={{ fontSize: '20px' }} />
            </IconButton>
          </Tooltip>

          {this.state.loading ? (
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '20px'
            }}>
              <CircularProgress size={60} />
              <div style={{
                textAlign: 'center',
                fontSize: '18px',
                color: '#263238'
              }}>
                {this.state.isProcessing
                  ? this.state.processingMessage || "Processing GSTR-1 Reconciliation..."
                  : "Loading GSTR-1 Reconciliation Report..."}
              </div>
              <div style={{
                fontSize: '14px',
                color: '#666',
                textAlign: 'center',
                maxWidth: '400px'
              }}>
                Please wait while we prepare your reconciliation report. This may take a few moments.
        </div>
            </div>
          ) : (
            <div style={{
              textAlign: 'center',
              fontSize: '16px',
              color: '#666'
            }}>
              If you are not redirected automatically, please go back and try again.
            </div>
          )}
        </div>

        <Snackbar
          anchorOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          open={this.state.snackbarOpen}
          autoHideDuration={5000}
          onClose={this.handleSnackbarClose}
        >
          <MuiAlert
            elevation={6}
            variant="filled"
            onClose={this.handleSnackbarClose}
            severity={this.state.snackbarSeverity}
          >
            {this.state.snackbarMessage}
          </MuiAlert>
        </Snackbar>
      </React.Fragment>
    );
  }
}
export default withRouter(GSTReconciliation); 